import {
    createFeatureReducer,
    FeatureActionReducer,
    PayloadAction
} from '../../store/store.utils';
import { UserAuth } from './auth.state';
import { AuthState, initialAuthState } from './auth.state';
import { AuthErrorCode } from '../../../../common/models/auth-api.interface';

abstract class AuthActionReducer extends FeatureActionReducer<AuthState> {
    protected constructor(name: string) {
        super('Auth', name);
    }
}

export class InvalidateJWT extends AuthActionReducer {
    constructor() {
        super('Invalidate JWT');
    }
    reduce(state: AuthState): AuthState {
        return {
            ...state,
            data: {
                ...state.data,
                claims: null,
                jwt: null
            }
        };
    }
}

export class ValidateJWTRequest extends AuthActionReducer {
    constructor() {
        super('Validate Request');
    }
    reduce(state: AuthState): AuthState {
        return {
            ...state,
            ui: {
                showFrame: true
            }
        };
    }
}

export class ValidateJWTSuccess
    extends AuthActionReducer
    implements PayloadAction<UserAuth>
{
    constructor(public readonly payload: UserAuth) {
        super('Validate Success');
    }
    reduce(state: AuthState): AuthState {
        return {
            ui: {
                showFrame: false
            },
            data: {
                jwt: this.payload.jwt,
                claims: this.payload.claims
            }
        };
    }
}

export class ValidateJWTError
    extends AuthActionReducer
    implements PayloadAction<any>
{
    constructor(public readonly payload: AuthErrorCode) {
        super('Validate Error');
    }
    reduce(state: AuthState): AuthState {
        return {
            ui: {
                showFrame: false
            },
            data: {
                jwt: null,
                claims: null
            }
        };
    }
}

const typedReducer = createFeatureReducer(AuthActionReducer, initialAuthState);
export function authReducer(state: any, action: any) {
    return typedReducer(state, action);
}
